<script setup lang="ts">
import ActionButton from '@/components/Elements/Buttons/ActionButton.vue'
import AlertBox from '@/components/Elements/Alerts/AlertBox.vue'
import TutorialFrame from '@/components/Interface/Modal/Modals/Tutorial/TutorialFrame.vue'
import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { handleNext } from '../tutorialSteps'
import GenericIcon from '@/components/Elements/Images/Icons/GenericIcon.vue'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const route = useRoute()
const router = useRouter()

const handleNextStep = async () => {
  await handleNext('tutorial_news_notification')
}

const isOnNotificationsSection = computed(() => {
  return route.path.startsWith('/news/notifications')
})

const goToNotifications = () => {
  router.push('/news/notifications')
}
</script>

<template>
  <TutorialFrame 
    video-url="https://cdn.ferion.com/videos/advisors/temperate/news.webm"
  >
    <template #text>
      <p class="pb-2">
        {{ t('tutorial.news.notification.busy') }}
      </p>
      <p class="pb-2">
        {{ t('tutorial.news.notification.notifyDirectly') }}
      </p>
    </template>

    <template #alerts>
      <AlertBox type="info" class="hidden md:flex">
        <i18n-t keypath="tutorial.news.notification.desktop" tag="span">
          <template #icon><GenericIcon type="bell"/></template>
        </i18n-t>
      </AlertBox>
      <AlertBox type="info" class="md:hidden">
        <i18n-t keypath="tutorial.news.notification.mobile" tag="span">
          <template #icon><GenericIcon type="bell"/></template>
        </i18n-t>
      </AlertBox>
    </template>

    <template #buttons>
      <ActionButton v-if="!isOnNotificationsSection" @click="goToNotifications" class="mr-2">
        {{ t('tutorial.news.notification.goToNotifications') }}
      </ActionButton>
      <ActionButton @click="handleNextStep">
        {{ t('common.actions.continue') }}
      </ActionButton>
    </template>
  </TutorialFrame>
</template>

<style scoped lang="scss">

</style>